import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, Flame, Wallet, Users, Youtube, UtensilsCrossed } from 'lucide-react';
export function PainPoints() {
  const points = [{
    icon: <AlertCircle className="w-5 h-5 md:w-6 md:h-6 text-brand-red" data-id="element-172" />,
    title: 'No sabés por dónde empezar',
    desc: 'Abrís la heladera y no se te ocurre nada. Terminás pidiendo delivery otra vez.'
  }, {
    icon: <Flame className="w-5 h-5 md:w-6 md:h-6 text-brand-red" data-id="element-173" />,
    title: 'Lo quemás o queda crudo',
    desc: 'La temperatura, los tiempos, el orden. Nadie te explicó cómo funciona la cocina de verdad.'
  }, {
    icon: <Wallet className="w-5 h-5 md:w-6 md:h-6 text-brand-red" data-id="element-174" />,
    title: 'Gastás de más en comida',
    desc: 'Entre el delivery, el almuerzo afuera y lo que tirás a la basura, se va más plata de la que calculás.'
  }, {
    icon: <Users className="w-5 h-5 md:w-6 md:h-6 text-brand-red" data-id="element-175" />,
    title: 'Te da vergüenza cocinar para otros',
    desc: 'Cuando hay visitas o familia, el estrés es real. Sobre todo si viene la suegra.'
  }, {
    icon: <Youtube className="w-5 h-5 md:w-6 md:h-6 text-brand-red" data-id="element-176" />,
    title: 'Los videos de YouTube no funcionan',
    desc: 'Seis canales distintos, todos dicen algo diferente. Seguís sin saber cocinar.'
  }, {
    icon: <UtensilsCrossed className="w-5 h-5 md:w-6 md:h-6 text-brand-red" data-id="element-177" />,
    title: 'Siempre lo mismo',
    desc: 'Fideos con manteca o huevos revueltos. Comés aburrido y sin nutrición real.'
  }];
  return <section className="py-8 md:py-14 relative" data-id="element-178">
      <div className="max-w-5xl mx-auto px-4 md:px-6" data-id="element-179">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6 md:mb-10" data-id="element-180">
          <span className="text-brand-red font-bold tracking-widest uppercase text-xs md:text-sm mb-2 md:mb-3 block" data-id="element-181">
            ¿Te pasa esto?
          </span>
          <h2 className="text-xl md:text-4xl font-serif font-bold text-white" data-id="element-182">
            Si nunca cocinaste, esto te suena familiar:
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2.5 md:gap-4" data-id="element-183">
          {points.map((p, i) => <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} key={i} className="glass-panel p-3 md:p-4 rounded-xl flex gap-3" data-id="element-184">
              <div className="bg-brand-red/10 w-9 h-9 md:w-10 md:h-10 rounded-lg flex items-center justify-center flex-shrink-0 border border-brand-red/20" data-id="element-185">
                {p.icon}
              </div>
              <div className="min-w-0" data-id="element-186">
                <h3 className="text-sm md:text-base font-bold text-white mb-0.5 leading-tight" data-id="element-187">
                  {p.title}
                </h3>
                <p className="text-xs md:text-sm text-gray-400 leading-snug" data-id="element-188">
                  {p.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-6 md:mt-10 text-center" data-id="element-189">
          <p className="text-base md:text-2xl font-serif italic text-brand-gold" data-id="element-190">
            ¿Cuántas semanas más vas a comer mal gastando de más?
          </p>
        </motion.div>
      </div>
    </section>;
}